import * as yup from 'yup';

import { ICON_SETS } from '../../constants/icons';
import { ObjectTypeBase } from '../../baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../Property';
import { TypeContextEnum } from '../TypeContextEnum';
import { Types } from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

export class IconType extends ObjectTypeBase {
  group = TYPE_GROUP_OTHER;

  contexts = [
    TypeContextEnum.Block,
    TypeContextEnum.Content,
    TypeContextEnum.Properties,
  ];

  name = 'Icon';

  friendlyName = 'Icon';
  properties = {
    color: {
      type: 'Color',
      friendlyName: 'Icon Color',
      default: null,
    },
    name: {
      type: 'String',
      friendlyName: 'Icon',
      validators: [
        {
          name: 'Max',
          value: 255,
        },
      ],
    },
    size: {
      type: 'Em',
      friendlyName: 'Icon Size',
      validators: [
        {
          name: 'Max',
          value: 100,
        },
        {
          name: 'Min',
          value: 5,
        },
      ],
    },
    set: {
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'In',
          value: ICON_SETS,
        },
      ],
    },
  } as PropertiesInterface;

  get example() {
    return {
      name: 'exclamation-circle',
      set: 'Feather',
      color: null,
      size: 24,
    };
  }

  get default(): any {
    return {
      name: 'exclamation-circle',
      set: 'Feather',
      color: null,
      size: 24,
    };
  }

  buildSchema() {
    return yup
      .object()
      .shape({
        set: yup.string().required().oneOf(ICON_SETS),
        name: yup.string().required(),
      })
      .nullable();
  }
}

const definition = new IconType();

Types.addBaseType(definition);
export { definition as IconDefinition };
